import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

export const useRouteCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(`${url}/api/routes`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res;
    },
    onSuccess: (data: any) => {
      console.log("✅ Route Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Route create request failed:", error);
      return error;
    },
  });
};

export const useFetchRoutesData = (
  page?: number,
  limit?: number,
  searchFor?: string
) => {
  return useQuery({
    queryKey: ["routesData"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/routes?page=${page}&limit=${limit}&searchFor=${searchFor}`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchWarehouseRoutesData = (warehouseId: string) => {
  return useQuery({
    queryKey: ["warehouseRoutesData", warehouseId],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/routes/warehouse/${warehouseId}`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    enabled: !!warehouseId,
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchRouteDetailsData = (id?: string) => {
  return useQuery({
    queryKey: ["RouteDetails", id],
    queryFn: async () => {
      if (!id) return null; // 👈 early exit inside the hook logic
      const res = await fetch3(`${url}/api/routes/${id}?type=LM`, "get");
      if (!res || !res.data) return res.message;
      return res.data;
    },
    enabled: !!id, // 👈 run only when id exists
    staleTime: 1000 * 60 * 5,
  });
};

export const useRouteUpdateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/routes/${payload?.id}`,
        "PATCH",
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Route update request failed";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Route updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Route update request failed:", error.message);
    },
  });
};

export const useRouteStatusMutation = (id: string) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/routes/${id}/status`,
        "PUT",
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Role status update request failed";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Role Status updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Role status update request failed:", error.message);
    },
  });
};
